import { ApiPatientRepository } from 'repository/api-patient-repository'
import { ApiResponse } from 'service/protocols/api-patient/api-patient-client'
import {
  IApiPatientRepository,
  RepositoryRequest
} from 'service/protocols/api-patient/api-patient-repository'
import { GetStorage } from 'service/protocols/cache/get-storage'
import { getEnv } from 'infra/config/env'

export class PrepareApiRequestPatientDecorator
  implements IApiPatientRepository
{
  constructor(
    private readonly getStorage: GetStorage,
    private readonly apiPatientRepository: ApiPatientRepository
  ) {}

  async get(data: RepositoryRequest): Promise<ApiResponse> {
    const account = this.getStorage.get('account')
    if (account?.accessToken) {
      Object.assign(data, {
        headers: Object.assign(data.headers || {}, {
          authorization: 'Bearer ' + account.accessToken
        })
      })
    }
    data.url =
      process.env.NODE_ENV === 'production'
        ? `/proxy-patient${data.url}`
        : `${getEnv('REACT_APP_API_MATERDEI_PATIENT_URL') + data.url}`

    return await this.apiPatientRepository.get(data)
  }

  async put(data: RepositoryRequest): Promise<ApiResponse> {
    const account = this.getStorage.get('account')
    if (account?.accessToken) {
      Object.assign(data, {
        headers: Object.assign(data.headers || {}, {
          authorization: 'Bearer ' + account.accessToken
        })
      })
    }
    data.url =
      process.env.NODE_ENV === 'production'
        ? `/proxy-patient${data.url}`
        : `${getEnv('REACT_APP_API_MATERDEI_PATIENT_URL') + data.url}`

    return await this.apiPatientRepository.put(data)
  }

  async post(data: RepositoryRequest): Promise<ApiResponse> {
    const account = this.getStorage.get('account')
    if (account?.accessToken) {
      Object.assign(data, {
        headers: Object.assign(data.headers || {}, {
          authorization: 'Bearer ' + account.accessToken
        })
      })
    }
    data.url =
      process.env.NODE_ENV === 'production'
        ? `/proxy-patient${data.url}`
        : `${getEnv('REACT_APP_API_MATERDEI_PATIENT_URL') + data.url}`

    return await this.apiPatientRepository.post(data)
  }

  delete(data: RepositoryRequest): Promise<ApiResponse> {
    const account = this.getStorage.get('account')
    if (account?.accessToken) {
      Object.assign(data, {
        headers: Object.assign(data.headers || {}, {
          authorization: 'Bearer ' + account.accessToken
        })
      })
    }
    data.url =
      process.env.NODE_ENV === 'production'
        ? `/proxy-patient${data.url}`
        : `${getEnv('REACT_APP_API_MATERDEI_PATIENT_URL') + data.url}`

    return this.apiPatientRepository.put(data)
  }
}
